import React from 'react';

import { useCopyToClipboard } from 'components/basic/icons/CopyToClipboard';
import MaterialSymbol from 'components/basic/icons/MaterialSymbol';
import { useSelector } from 'reduxState/store';

import { MenuItemType } from '../headerTypes';
import MenuItemRenderer from '../MenuItemRenderer';

function WalletCopyAddressItem() {
  const walletAddress = useSelector(
    state => state.wallet.walletAddressOriginal
  );
  const { onCopy, recentlyCopied } = useCopyToClipboard();

  if (!walletAddress) {
    return null;
  }

  return (
    <MenuItemRenderer
      linkProps={{
        onClick: () => onCopy(walletAddress),
        icon: recentlyCopied ? (
          <MaterialSymbol icon="done" fontSize="small" color="var(--gray4c)" />
        ) : (
          <MaterialSymbol
            icon="content_copy"
            fontSize="small"
            color="var(--gray4c)"
          />
        ),
      }}
      menuItem={{
        type: 'DropdownMenuLink' as const,
        label: 'Copy Address',
      }}
    />
  );
}

const walletCopyAddressItem: MenuItemType = {
  type: 'MenuBox',
  Component: WalletCopyAddressItem,
};

export default walletCopyAddressItem;
